import React, { useEffect, useRef, useState } from "react";
import { useTranslate } from "../components/TranslationText";
import Loader from "../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import NetaqInput from "../components/NetaqInput";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router";
import { ToastContainer, toast } from "react-toastify";
import {
  FetchCreateOrEditExportHorseSementhunk,
  FetchCreateOrEditImportHorseFrozenSemenServiceRequestthunk,
  FetchGetServiceDefinitionByIdthunk,
  FetchGetServicesRequestByIdthunk,
  FetchGetShippingAgentsthunk,
  FetchOwnerImportHorseFrozenSemenListthunk,
  FetchOwnerStallionsthunk,
} from "../Redux/ServicesRequests/ServicesRequestsAction";
import {
  resetGetServicesRequestByIdData,
  resetToasterMessageServicesRequests,
} from "../Redux/ServicesRequests/ServicesRequestsSlice";
import { FetchSubOwnerProfilesByIdthunk } from "../Redux/ShowEntry/ShowEntryAction";
import dayjs from "dayjs";
import EahsForm from "../components/EahsForm";
import { FetchStudBookCountriesthunk } from "../Redux/StudBook/StudBookAction";
import SimpleFileUpload from "../components/SimpleFileUpload";
import { base64ToBlob } from "../helper/base64ToBlob";
import PillBtn from "../components/PillBtn";
import DraftBtn from "../components/servicesButtons/DraftBtn";
import ApproveAndPayLaterBtn from "../components/servicesButtons/ApproveAndPayLaterBtn";
import SubmitServiceBtn from "../components/servicesButtons/SubmitServiceBtn";
import SubmitAndPay from "../components/servicesButtons/SubmitAndPay";
import { eFormButtonsContainer, eformCheckBox, eformInput, eformTerms, serviceRequestHeadContainer, serviceRequestTitle, userDropDown } from "../common/cssclasses";
import { FetchCountriesthunk, FetchHorseColorsthunk } from "../Redux/LookUp/LookUpAction";
import { isLessThanUndefinedYearOld } from "../helper/isLessThanUndefinedYearOld";

export default function ExportHorseSemen() {
  //env 
  const UMBRACOURL = process.env.REACT_APP_UMBRACO;
  // const UMBRACOURL = process.env.REACT_APP_Local_UMBRACO;
  const BaseURL = process.env.REACT_APP_BASE_URL;

  //selector
  const { studBookCountries, currentLanguage } = useSelector((state) => state.studBookSlice);
  const { countriesData, horseColorsData } = useSelector(
    (state) => state.lookUpSlice
  );

  const {
    toasterMessageServicesRequests,
    servicesRequestsLoading,
    getServicesRequestByIdData,
    getServiceDefinitionByIdData,
    createOrEditExportHorseSemenData,
    getShippingAgentsData,
    ownerStallionsData,
    ownerImportHorseFrozenSemenListData,
  } = useSelector((state) => state.servicesRequestsSlice);

  const userProfile = JSON.parse(localStorage.getItem("eahsUserProfile"));
  const subOwnerProfilesByIdData = userProfile?.subAccounts ?? [];

  const dispatch = useDispatch();

  const { translate } = useTranslate();

  const navigate = useNavigate();

  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  const serviceId = searchParams.has("serviceId")
    ? searchParams.get("serviceId")
    : null;

  const id = searchParams.has("id") ? searchParams.get("id") : null;

  const action = searchParams.has("action") ? searchParams.get("action") : null;
  const ownerId = searchParams.has("ownerId") ? searchParams.get("ownerId") : null;

  //state
  const [formModel, setFormModel] = useState({
    id: "",
    exportHorseSemenId: "",
    eventName: "",
    comment: "",
    referenceNumber: "",
    requestsType: "",
    paymentStatus: "",

    stallionId: "",
    stallionDrop: {
      label: translate("web.horse", "Horse"),
      value: null,
    },

    horseType: "Registered",
    // horseNameEnUnReg: "",
    // horseNameArUnReg: "",
    // damEnUnReg: "",
    // damArUnReg: "",
    // sireEnUnReg: "",
    // sireArUnReg: "",
    // breederNameEnUnReg: "",
    // breederNameArUnReg: "",
    // regoNoUnReg: "",
    // colorUnReg: "",
    // colorUnRegDrop: {
    //   label: translate("web.color", "Color"),
    //   value: null,
    // },
    // originUnReg: "",
    // originUnRegDrop: {
    //   label: translate("web.chooseOrigin", "Choose Origin"),
    //   value: null,
    // },
    // horseCountryUnReg: "",
    // horseCountryUnRegDrop: {
    //   label: translate("web.horseCountry", "Horse Country"),
    //   value: null,
    // },

    // birthDateUnReg: null,

    importHorseFrozenSemenServiceId: "",
    importHorseFrozenSemenServiceIdDrop: {
      label: translate("web.importHorseFrozenSemen", "Import Horse Frozen Semen"),
      value: null,
    },

    semenCollectionCertificateIds: [],
    semenCollectionCertificateIdsDrop: [],

    exportDate: null,

    exportTo: "",
    exportToDrop: {
      label: translate("web.chooseCountry", "Choose Country"),
      value: null,
    },

    approvedCollectionCenter: "",
    noOfDoses: null,
    dispatchNumber: null,
    noOfStraws: null,
    uaeHospitalSemenStocking: "",
    shippingAgentId: "",
    shippingAgentDrop: {
      label: translate("web.shippingAgent", "Shipping Agent"),
      value: null,
    },
    shippingAgentNameEn: "",
    shippingAgentNameAr: "",
    shippingAgentMobile: "",
    shippingAgentEmail: "",

    ownerComment: "",

    filePathLetterSemenStorageCenter: "",
    fileTypeLetterSemenStorageCenter: "",
    fileNameLetterSemenStorageCenter: "",
    fileUrlLetterSemenStorageCenter: "",
    letterSemenStorageCenterAttachmentFile: null,
  });

  const [semenCertList, setSemenCertList] = useState([]);

  const [errorStallionId, setErrorStallionId] = useState(false);
  const [errorExportDate, setErrorExportDate] = useState(false);
  const [errorExportTo, setErrorExportTo] = useState(false);
  const [errorApprovedCollectionCenter, setErrorApprovedCollectionCenter] = useState(false);
  const [errorNoOfDoses, setErrorNoOfDoses] = useState(false);
  const [errorDispatchNumber, setErrorDispatchNumber] = useState(false);
  const [errorNoOfStraws, setErrorNoOfStraws] = useState(false);
  const [errorUaeHospitalSemenStocking, setErrorUaeHospitalSemenStocking] = useState(false);
  const [errorShippingAgentId, setErrorShippingAgentId] = useState(false);
  const [errorShippingAgentNameEn, setErrorShippingAgentNameEn] = useState(false);
  const [errorShippingAgentNameAr, setErrorShippingAgentNameAr] = useState(false);
  const [errorShippingAgentMobile, setErrorShippingAgentMobile] = useState(false);
  const [errorShippingAgentEmail, setErrorShippingAgentEmail] = useState(false);
  const [errorLetterSemenStorageCenter, setErrorLetterSemenStorageCenter] = useState(false);

  // const [errorHorseNameEnUnReg, setErrorHorseNameEnUnReg] = useState(false);
  // const [errorHorseNameArUnReg, setErrorHorseNameArUnReg] = useState(false);
  // const [errorDamEnUnReg, setErrorDamEnUnReg] = useState(false);
  // const [errorDamArUnReg, setErrorDamArUnReg] = useState(false);
  // const [errorSireEnUnReg, setErrorSireEnUnReg] = useState(false);
  // const [errorSireArUnReg, setErrorSireArUnReg] = useState(false);
  // const [errorBreederNameEnUnReg, setErrorBreederNameEnUnReg] = useState(false);
  // const [errorBreederNameArUnReg, setErrorBreederNameArUnReg] = useState(false);
  // const [errorRegoNoUnReg, setErrorRegoNoUnReg] = useState(false);
  // const [errorColorUnReg, setErrorColorUnReg] = useState(false);
  // const [errorOriginUnReg, setErrorOriginUnReg] = useState(false);
  // const [errorHorseCountryUnReg, setErrorHorseCountryUnReg] = useState(false);
  // const [errorBirthDateUnReg, setErrorBirthDateUnReg] = useState(false);

  const [errorImportHorseFrozenSemenServiceId, setErrorImportHorseFrozenSemenServiceId] = useState(false);
  const [errorSemenCollectionCertificateIds, setErrorSemenCollectionCertificateIds] = useState(false);

  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);

  //use ref
  const stallionIdRef = useRef(null);
  const exportDateRef = useRef(null);
  const exportToRef = useRef(null);
  const approvedCollectionCenterRef = useRef(null);
  const noOfDosesRef = useRef(null);
  const dispatchNumberRef = useRef(null);
  const noOfStrawsRef = useRef(null);
  const uaeHospitalSemenStockingRef = useRef(null);
  const shippingAgentIdRef = useRef(null);
  const shippingAgentNameEnRef = useRef(null);
  const shippingAgentNameArRef = useRef(null);
  const shippingAgentMobileRef = useRef(null);
  const shippingAgentEmailRef = useRef(null);
  const letterSemenStorageCenterRef = useRef(null);

  // const horseNameEnUnRegRef = useRef(null);
  // const horseNameArUnRegRef = useRef(null);
  // const damEnUnRegRef = useRef(null);
  // const damArUnRegRef = useRef(null);
  // const sireEnUnRegRef = useRef(null);
  // const sireArUnRegRef = useRef(null);
  // const breederNameEnUnRegRef = useRef(null);
  // const breederNameArUnRegRef = useRef(null);
  // const regoNoUnRegRef = useRef(null);
  // const colorUnRegRef = useRef(null);
  // const originUnRegRef = useRef(null);
  // const horseCountryUnRegRef = useRef(null);
  // const birthDateUnRegRef = useRef(null);

  const importHorseFrozenSemenServiceIdRef = useRef(null);

  const semenCollectionCertificateIdsRef = useRef(null);

  const _isOnlinePayment = useRef("");
  const _status = useRef("");

  const [
    letterSemenStorageCenterAttachmentFile,
    setLetterSemenStorageCenterAttachmentFile,
  ] = useState([]);

  const [checkedItems, setCheckedItems] = useState({});

  const [profile, setProfile] = useState({
    label:
      !!userProfile &&
      userProfile?.ownerRegisterNo +
      " - " +
      userProfile[`fullName${currentLanguage === "en" ? "" : "Ar"}`],
    value: localStorage.getItem("EAHSUserID"),
  });

  const subAccountId = localStorage.getItem("currentSubAccountId");

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 50,
      minHeight: 50,
    }),
  };

  //function
  const handleFormChange = (e, input) => {
    if (input === "stallion") {
      setFormModel({
        ...formModel,
        stallionId: e.value,
        stallionDrop: e,
      });
    }
    else if (input === "horseType") {
      const isUnreg = e.target.value === "UnRegistered";

      setFormModel({
        ...formModel,
        horseType: e.target.value,

        noOfDoses: isUnreg ? formModel.semenCollectionCertificateIds.length : formModel.noOfDoses,

        stallionId: "",
        stallionDrop: {
          label: translate("web.horse", "Horse"),
          value: null,
        },
        importHorseFrozenSemenServiceId: "",
        importHorseFrozenSemenServiceIdDrop: {
          label: translate("web.importHorseFrozenSemen", "Import Horse Frozen Semen"),
          value: null,
        },
        semenCollectionCertificateIds: [],
        semenCollectionCertificateIdsDrop: []

        // horseNameEnUnReg: "",
        // horseNameArUnReg: "",
        // damEnUnReg: "",
        // damArUnReg: "",
        // sireEnUnReg: "",
        // sireArUnReg: "",
        // breederNameEnUnReg: "",
        // breederNameArUnReg: "",
        // regoNoUnReg: "",
        // colorUnReg: "",
        // colorUnRegDrop: {
        //   label: translate("web.color", "Color"),
        //   value: null,
        // },
        // originUnReg: "",
        // originUnRegDrop: {
        //   label: translate("web.chooseOrigin", "Choose Origin"),
        //   value: null,
        // },
        // horseCountryUnReg: "",
        // horseCountryUnRegDrop: {
        //   label: translate("web.horseCountry", "Horse Country"),
        //   value: null,
        // },
        // birthDateUnReg: null,
      });
    }
    else if (input === "importHorseFrozenSemenServiceId") {
      setFormModel(prev => ({
        ...prev,
        importHorseFrozenSemenServiceId: e.value,
        importHorseFrozenSemenServiceIdDrop: e,
        // clear out the child dropdown
        semenCollectionCertificateIds: [],
        semenCollectionCertificateIdsDrop: [],
        noOfDoses: prev.horseType === "UnRegistered"
          ? 0
          : prev.noOfDoses
      }));
      return;
    }

    else if (input === "semenCollectionCertificateIds") {
      const selected = e || [];            // e is an array of option-objects
      const isUnreg = formModel?.horseType === "UnRegistered";
      setFormModel(prev => ({
        ...prev,
        // store the raw ids
        semenCollectionCertificateIds: selected.map(opt => opt.value),
        // store the options so <Select> renders them
        noOfDoses: isUnreg ? formModel.semenCollectionCertificateIds.length : formModel.noOfDoses,
        semenCollectionCertificateIdsDrop: selected,
        // if UnRegistered, override noOfDoses to count of certificates
        noOfDoses:
          prev.horseType === "UnRegistered"
            ? selected.length
            : prev.noOfDoses
      }));
      debugger
      return;
    }

    // else if (!!input && input === "horseNameEnUnReg") {
    //   const regex = /^[^\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]*$/;
    //   if (regex.test(e.target.value)) {
    //     setFormModel({
    //       ...formModel,
    //       horseNameEnUnReg: e.target.value.toUpperCase(),
    //     });
    //   }
    // }
    // else if (!!input && input === "damEnUnReg") {
    //   const regex = /^[^\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]*$/;
    //   if (regex.test(e.target.value)) {
    //     setFormModel({
    //       ...formModel,
    //       damEnUnReg: e.target.value.toUpperCase(),
    //     });
    //   }
    // }
    // else if (!!input && input === "sireEnUnReg") {
    //   const regex = /^[^\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]*$/;
    //   if (regex.test(e.target.value)) {
    //     setFormModel({
    //       ...formModel,
    //       sireEnUnReg: e.target.value.toUpperCase(),
    //     });
    //   }
    // }
    // else if (!!input && input === "breederNameEnUnReg") {
    //   const regex = /^[^\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]*$/;
    //   if (regex.test(e.target.value)) {
    //     setFormModel({
    //       ...formModel,
    //       breederNameEnUnReg: e.target.value.toUpperCase(),
    //     });
    //   }
    // }
    // else if (!!input && input === "colorUnReg") {
    //   setFormModel({
    //     ...formModel,
    //     colorUnReg: e.value,
    //     colorUnRegDrop: e,
    //   });
    // }
    // else if (!!input && input === "originUnReg") {
    //   setFormModel({
    //     ...formModel,
    //     originUnReg: e.value,
    //     originUnRegDrop: e,
    //   });
    // }
    // else if (!!input && input === "horseCountryUnReg") {
    //   setFormModel({
    //     ...formModel,
    //     horseCountryUnReg: e.value,
    //     horseCountryUnRegDrop: e,
    //   });
    // }
    // else if (!!input && input === "birthDateUnReg") {
    //   setFormModel({
    //     ...formModel,
    //     birthDateUnReg: e.target.value,
    //   });
    // }

    else if (input === "exportTo") {
      setFormModel({
        ...formModel,
        exportTo: e.value,
        exportToDrop: e,
      });
    }
    else if (input === "shippingAgent") {
      setFormModel({
        ...formModel,
        shippingAgentId: e.value,
        shippingAgentDrop: e,
      });
    }
    else if (!!input && input === "shippingAgentNameEn") {
      const regex = /^[^\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]*$/;

      if (regex.test(e.target.value)) {
        setFormModel({
          ...formModel,
          shippingAgentNameEn: e.target.value,
        });
      }
    }
    else {
      setFormModel({
        ...formModel,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleUploadLetterSemenStorageCenterChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].size > 10 * 1024 * 1024) {
        toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
      } else {
        setFormModel({
          ...formModel,
          letterSemenStorageCenterAttachmentFile: e.target.files[0],
        });

        setLetterSemenStorageCenterAttachmentFile([
          {
            file: e.target.files[0],
            name: e.target.files[0].name,
          },
        ]);
      }
    }
  };

  const setPhoneNumber = (value) => {
    setFormModel((prev) => ({
      ...prev,
      shippingAgentMobile: value
    }));
  }

  const validInputs = () => {
    let valid = true;

    if (
      formModel.horseType === "Registered" &&
      formModel.stallionId === ""
    ) {
      setErrorStallionId(true);
      valid = false;

      stallionIdRef?.current?.focus();
      return;
    }
    else {
      setErrorStallionId(false);
    }

    if (formModel.horseType === "UnRegistered") {
      if (
        formModel.importHorseFrozenSemenServiceId === ""
      ) {
        setErrorImportHorseFrozenSemenServiceId(true);
        valid = false;

        importHorseFrozenSemenServiceIdRef?.current?.focus();
        return;
      }
      else {
        setErrorImportHorseFrozenSemenServiceId(false);
      }

      if (
        !formModel.semenCollectionCertificateIds || formModel.semenCollectionCertificateIds.length === 0
      ) {
        setErrorSemenCollectionCertificateIds(true);
        valid = false;

        semenCollectionCertificateIdsRef?.current?.focus();
        return;
      }
      else {
        setErrorSemenCollectionCertificateIds(false);
      }

      // if (
      //   formModel.horseNameEnUnReg === ""
      // ) {
      //   setErrorHorseNameEnUnReg(true);
      //   valid = false;

      //   horseNameEnUnRegRef?.current?.focus();
      //   return;
      // }
      // else {
      //   setErrorHorseNameEnUnReg(false);
      // }
      // if (
      //   formModel.horseNameArUnReg === ""
      // ) {
      //   setErrorHorseNameArUnReg(true);
      //   valid = false;

      //   horseNameArUnRegRef?.current?.focus();
      //   return;
      // }
      // else {
      //   setErrorHorseNameArUnReg(false);
      // }
      // if (
      //   formModel.damEnUnReg === ""
      // ) {
      //   setErrorDamEnUnReg(true);
      //   valid = false;

      //   damEnUnRegRef?.current?.focus();
      //   return;
      // }
      // else {
      //   setErrorDamEnUnReg(false);
      // }
      // if (
      //   formModel.damArUnReg === ""
      // ) {
      //   setErrorDamArUnReg(true);
      //   valid = false;

      //   damArUnRegRef?.current?.focus();
      //   return;
      // }
      // else {
      //   setErrorDamArUnReg(false);
      // }
      // if (
      //   formModel.sireEnUnReg === ""
      // ) {
      //   setErrorSireEnUnReg(true);
      //   valid = false;

      //   sireEnUnRegRef?.current?.focus();
      //   return;
      // }
      // else {
      //   setErrorSireEnUnReg(false);
      // }
      // if (
      //   formModel.sireArUnReg === ""
      // ) {
      //   setErrorSireArUnReg(true);
      //   valid = false;

      //   sireArUnRegRef?.current?.focus();
      //   return;
      // }
      // else {
      //   setErrorSireArUnReg(false);
      // }
      // if (
      //   formModel.breederNameEnUnReg === ""
      // ) {
      //   setErrorBreederNameEnUnReg(true);
      //   valid = false;

      //   breederNameEnUnRegRef?.current?.focus();
      //   return;
      // }
      // else {
      //   setErrorBreederNameEnUnReg(false);
      // }
      // if (
      //   formModel.breederNameArUnReg === ""
      // ) {
      //   setErrorBreederNameArUnReg(true);
      //   valid = false;

      //   breederNameArUnRegRef?.current?.focus();
      //   return;
      // }
      // else {
      //   setErrorBreederNameArUnReg(false);
      // }
      // if (
      //   formModel.regoNoUnReg === ""
      // ) {
      //   setErrorRegoNoUnReg(true);
      //   valid = false;

      //   regoNoUnRegRef?.current?.focus();
      //   return;
      // }
      // else {
      //   setErrorRegoNoUnReg(false);
      // }
      // if (
      //   formModel.colorUnReg === ""
      // ) {
      //   setErrorColorUnReg(true);
      //   valid = false;

      //   colorUnRegRef?.current?.focus();
      //   return;
      // }
      // else {
      //   setErrorColorUnReg(false);
      // }
      // if (
      //   formModel.originUnReg === ""
      // ) {
      //   setErrorOriginUnReg(true);
      //   valid = false;

      //   originUnRegRef?.current?.focus();
      //   return;
      // }
      // else {
      //   setErrorOriginUnReg(false);
      // }
      // if (
      //   formModel.horseCountryUnReg === ""
      // ) {
      //   setErrorHorseCountryUnReg(true);
      //   valid = false;

      //   horseCountryUnRegRef?.current?.focus();
      //   return;
      // }
      // else {
      //   setErrorHorseCountryUnReg(false);
      // }
      // if (
      //   formModel.birthDateUnReg === null || (!!formModel.birthDateUnReg && isLessThanUndefinedYearOld(new Date(formModel.birthDateUnReg), 2))
      // ) {
      //   setErrorBirthDateUnReg(true);
      //   valid = false;

      //   birthDateUnRegRef?.current?.focus();

      //   if ((!!formModel.birthDateUnReg && isLessThanUndefinedYearOld(new Date(formModel.birthDateUnReg), 2))) {
      //     toast.error(
      //       translate("web.horseTooYoungToRequest", "Horse Too Young To Request")
      //     );
      //   }

      //   return;
      // }
      // else {
      //   setErrorBirthDateUnReg(false);
      // }
    }

    if (
      formModel.exportTo === ""
    ) {
      setErrorExportTo(true);
      valid = false;

      exportToRef?.current?.focus();
      return;
    }
    else {
      setErrorExportTo(false);
    }

    if (
      formModel.approvedCollectionCenter === ""
    ) {
      setErrorApprovedCollectionCenter(true);
      valid = false;

      approvedCollectionCenterRef?.current?.focus();
      return;
    }
    else {
      setErrorApprovedCollectionCenter(false);
    }

    if (
      formModel.noOfStraws === "" || formModel.noOfStraws == null || Number(formModel.noOfStraws) < 1
    ) {
      setErrorNoOfStraws(true);
      valid = false;

      noOfStrawsRef?.current?.focus();
      return;
    }
    else {
      setErrorNoOfStraws(false);
    }

    if (
      formModel.noOfDoses === "" || formModel.noOfDoses == null || Number(formModel.noOfDoses) < 1
    ) {
      setErrorNoOfDoses(true);
      valid = false;

      noOfDosesRef?.current?.focus();
      return;
    }
    else {
      setErrorNoOfDoses(false);
    }

    if (
      formModel.dispatchNumber === "" || formModel.dispatchNumber == null || Number(formModel.dispatchNumber) < 1
    ) {
      setErrorDispatchNumber(true);
      valid = false;

      dispatchNumberRef?.current?.focus();
      return;
    }
    else {
      setErrorDispatchNumber(false);
    }

    if (
      formModel.uaeHospitalSemenStocking === ""
    ) {
      setErrorUaeHospitalSemenStocking(true);
      valid = false;

      uaeHospitalSemenStockingRef?.current?.focus();
      return;
    }
    else {
      setErrorUaeHospitalSemenStocking(false);
    }

    if (
      formModel.exportDate === null
    ) {
      setErrorExportDate(true);
      valid = false;

      exportDateRef?.current?.focus();
      return;
    }
    else {
      setErrorExportDate(false);
    }

    if (
      formModel.shippingAgentId === ""
    ) {
      setErrorShippingAgentId(true);
      valid = false;

      shippingAgentIdRef?.current?.focus();
      return;
    }
    else {
      setErrorShippingAgentId(false);
    }

    if (
      formModel.shippingAgentId === 0
    ) {

      if (
        formModel.shippingAgentNameEn === ""
      ) {
        setErrorShippingAgentNameEn(true);
        valid = false;

        shippingAgentNameEnRef?.current?.focus();
        return;
      }
      else {
        setErrorShippingAgentNameEn(false);
      }

      if (
        formModel.shippingAgentNameAr === ""
      ) {
        setErrorShippingAgentNameAr(true);
        valid = false;

        shippingAgentNameArRef?.current?.focus();
        return;
      }
      else {
        setErrorShippingAgentNameAr(false);
      }

      if (
        formModel.shippingAgentEmail === ""
      ) {
        setErrorShippingAgentEmail(true);
        valid = false;

        shippingAgentEmailRef?.current?.focus();
        return;
      }
      else {
        setErrorShippingAgentEmail(false);
      }

      if (
        formModel.shippingAgentMobile === ""
      ) {
        setErrorShippingAgentMobile(true);
        valid = false;

        shippingAgentMobileRef?.current?.focus();
        return;
      }
      else {
        setErrorShippingAgentMobile(false);
      }
    }

    if (
      letterSemenStorageCenterAttachmentFile.length === 0
      && formModel.fileUrlLetterSemenStorageCenter === ""
    ) {
      setErrorLetterSemenStorageCenter(true);
      valid = false;

      letterSemenStorageCenterRef?.current?.focus();
      return;
    }
    else {
      setErrorLetterSemenStorageCenter(false);
    }

    //term
    if (Object.values(checkedItems).length > 0) {  // Optional safe check
      const allTermsChecked = Object.values(checkedItems).every((isChecked) => isChecked);

      if (!allTermsChecked && action == null) {
        toast.error(
          translate("web.pleaseCheckAllTerms", "Please Check All Terms")
        );
        valid = false;
      }
    }

    return valid;
  }

  const handelFormSubmit = (status, isOnlinePayment, buttonAction = 'Draft') => {
    if (getServiceDefinitionByIdData.serviceFees > 0 && formModel.paymentStatus === "Pendding" && formModel.requestsType === "BackOffice" && formModel.eventName !== "SentBack") {
      const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}&serviceId=${id}`;

      const encodeURI = encodeURIComponent(returnUrl);

      window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${id}&paymentType=28&userId=${localStorage.getItem("EAHSUserID")}&returnUrl=${encodeURI}&isOnline=${isOnlinePayment}&lang=${currentLanguage}`;
    }
    else {
      if (
        validInputs()
      ) {
        _isOnlinePayment.current = isOnlinePayment;
        _status.current = status;

        let params = {
          id: id == null ? '' : id,
          exportHorseSemenId: formModel.exportHorseSemenId,
          ownerId: getUserID(),
          stallionId: formModel.stallionId,
          horseType: formModel.horseType,
          importHorseFrozenSemenServiceId: formModel.importHorseFrozenSemenServiceId,
          semenCollectionCertificateIds: formModel.semenCollectionCertificateIds,

          // horseNameEnUnReg: formModel.horseNameEnUnReg,
          // horseNameArUnReg: formModel.horseNameArUnReg,
          // damEnUnReg: formModel.damEnUnReg,
          // damArUnReg: formModel.damArUnReg,
          // sireEnUnReg: formModel.sireEnUnReg,
          // sireArUnReg: formModel.sireArUnReg,
          // breederNameEnUnReg: formModel.breederNameEnUnReg,
          // breederNameArUnReg: formModel.breederNameArUnReg,
          // regoNoUnReg: formModel.regoNoUnReg,
          // colorUnReg: formModel.colorUnReg,
          // originUnReg: formModel.originUnReg,
          // horseCountryUnReg: formModel.horseCountryUnReg,
          // birthDateUnReg: formModel.birthDateUnReg == null ? '' : dayjs(formModel.birthDateUnReg).format("DD/MM/YYYY"),

          exportTo: formModel.exportTo,
          approvedCollectionCenter: formModel.approvedCollectionCenter,
          noOfStraws: formModel.noOfStraws,
          noOfDoses: formModel.noOfDoses,
          dispatchNumber: formModel.dispatchNumber,
          uaeHospitalSemenStocking: formModel.uaeHospitalSemenStocking,
          exportDate: formModel.exportDate != null ? dayjs(formModel.exportDate).format("DD/MM/YYYY") : '',
          shippingAgentId: formModel.shippingAgentId !== 0 ? formModel.shippingAgentId : '',
          shippingAgentNameEn: formModel.shippingAgentNameEn,
          shippingAgentNameAr: formModel.shippingAgentNameAr,
          shippingAgentEmail: formModel.shippingAgentEmail,
          shippingAgentMobile: formModel.shippingAgentMobile,
          letterSemenStorageCenterAttachmentFile: formModel.letterSemenStorageCenterAttachmentFile,
          status: status,
          ownerComment: formModel.ownerComment,
          buttonAction: buttonAction
        };

        dispatch(FetchCreateOrEditExportHorseSementhunk(params));
      }
      else {
        toast.error(
          translate("web.completeTheRequiredData", "Complete The Required Data")
        );
      }
    }
  };

  const handelSelectedAccountChange = async (element) => {
    let ownerId = element.value;

    dispatch(FetchOwnerStallionsthunk({ ownerId: ownerId, serviceDefinitionId: serviceId }));

    dispatch(FetchOwnerImportHorseFrozenSemenListthunk(ownerId));

    setProfile(element);

    setFormModel({
      ...formModel,
      stallionId: "",
      stallionDrop: {
        label: translate("web.horse", "Horse"),
        value: null,
      },
    });
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    setCheckedItems((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  function CheckIfAgentHasPermission() {
    const AgentHasPermission = userProfile.subAccounts
      .filter((x) => x.value == subAccountId)[0]
      .ownersPermissionsList.some(
        (x) =>
          x.permissionName === "ExportHorseSemen" || x.permissionName === "All"
      );
    return AgentHasPermission;
  }

  // const getUserID = () => {
  //   const userID =
  //     !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;
  //   return userID;
  // };
  const getUserID = () => {
    let userID =
      !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;
    if ((action == null || action === "edit") == false) {
      userID = subAccountId;
    }
    return userID;
  };

  const getSelectedAccountName = () => {
    const selectAccount = userProfile.subAccounts.filter(
      (x) => x.value == subAccountId
    );

    if (selectAccount.length > 0) {
      return selectAccount[0];
    }
    else {
      return false;
    }
  };

  const dismissAll = () => toast.dismiss();

  const handelDisabledButton = () => {
    if (
      action === "view"
      || (action === "approve" && formModel.eventName !== "SentBack")
    ) {
      return true;
    }
    else {
      return false;
    }
  };

  //Effect
  useEffect(() => {
    const svcId = formModel.importHorseFrozenSemenServiceId;

    if (svcId && Array.isArray(ownerImportHorseFrozenSemenListData)) {
      const svc = ownerImportHorseFrozenSemenListData.find(x => x.id === svcId);

      setSemenCertList(svc?.semenCollectionCertificatesList || []);
    } else {
      setSemenCertList([]);
    }
  }, [formModel.importHorseFrozenSemenServiceId, ownerImportHorseFrozenSemenListData]);

  useEffect(() => {
    if (id != null) {
      let params = {
        language: currentLanguage,
        id: id,
        ownerId: ownerId,
      };

      dispatch(FetchGetServicesRequestByIdthunk(params));
    }

    return () => {
      dispatch(resetGetServicesRequestByIdData());
    };
  }, []);

  useEffect(() => {
    if (!!userProfile && userProfile?.haveProfileSignture != true) {
      toast.error(
        translate(
          "web.completeOwnerProfileData",
          "Please complete the personal data of the profile."
        )
      );

      setTimeout(() => {
        navigate("/profile");
      }, 3000);
    }

    if (!!userProfile && userProfile?.accountType === "Agent") {
      if (userProfile.id == subAccountId) {
        navigate("/403-Not-Authrized");
      }

      if (!CheckIfAgentHasPermission()) {
        navigate("/403-Not-Authrized");
      }
    }

    dispatch(FetchCountriesthunk({ langauge: currentLanguage }));
    dispatch(FetchHorseColorsthunk({ langauge: currentLanguage }));

    let ownerId = getUserID();

    dispatch(FetchOwnerStallionsthunk({ ownerId: ownerId, serviceDefinitionId: serviceId }));

    dispatch(FetchOwnerImportHorseFrozenSemenListthunk(ownerId));

    let subOwnerProfilesParams = {
      id: getUserID(),
      langauge: currentLanguage,
    };
    dispatch(FetchSubOwnerProfilesByIdthunk(subOwnerProfilesParams));

    dispatch(FetchStudBookCountriesthunk(currentLanguage));

    dispatch(FetchGetShippingAgentsthunk());

    dispatch(FetchGetServiceDefinitionByIdthunk(serviceId));
  }, [currentLanguage]);

  useEffect(() => {
    if (getServicesRequestByIdData != null &&
      Object.keys(getServicesRequestByIdData).length > 0 && (getServicesRequestByIdData.serviceDefinitionId == serviceId)
    ) {
      setFormModel({
        ...formModel,
        eventName: getServicesRequestByIdData.eventName,
        comment: getServicesRequestByIdData.comment,
        requestsType: getServicesRequestByIdData.requestsType,
        paymentStatus: getServicesRequestByIdData.paymentStatus,
        referenceNumber: " - " + getServicesRequestByIdData.referenceNumber,

        exportHorseSemenId: getServicesRequestByIdData.exportHorseSemenDto.exportHorseSemenId,

        stallionId: getServicesRequestByIdData.exportHorseSemenDto.stallionId != null ? getServicesRequestByIdData.exportHorseSemenDto.stallionId : "",
        stallionDrop: {
          label: getServicesRequestByIdData.exportHorseSemenDto.stallionName,
          value: getServicesRequestByIdData.exportHorseSemenDto.stallionId,
        },
        importHorseFrozenSemenServiceId: getServicesRequestByIdData.exportHorseSemenDto.importHorseFrozenSemenServiceId != null ? getServicesRequestByIdData.exportHorseSemenDto.importHorseFrozenSemenServiceId : "",
        importHorseFrozenSemenServiceIdDrop: {
          label: getServicesRequestByIdData.exportHorseSemenDto.importHorseFrozenSemenServiceName,
          value: getServicesRequestByIdData.exportHorseSemenDto.importHorseFrozenSemenServiceId,
        },
        semenCollectionCertificateIds: getServicesRequestByIdData.exportHorseSemenDto.semenCollectionCertificateList != null ? getServicesRequestByIdData.exportHorseSemenDto.semenCollectionCertificateList : [],
        semenCollectionCertificateIdsDrop: getServicesRequestByIdData.exportHorseSemenDto.semenCollectionCertificateList != null ? getServicesRequestByIdData.exportHorseSemenDto.semenCollectionCertificateList.map((item) => ({
          label: item.name,
          value: item.id,
        })) : [],

        horseType: getServicesRequestByIdData.exportHorseSemenDto.horseType,
        // horseNameEnUnReg: getServicesRequestByIdData.exportHorseSemenDto.horseNameEnUnReg != null ? getServicesRequestByIdData.exportHorseSemenDto.horseNameEnUnReg : "",
        // horseNameArUnReg: getServicesRequestByIdData.exportHorseSemenDto.horseNameArUnReg != null ? getServicesRequestByIdData.exportHorseSemenDto.horseNameArUnReg : "",

        // damEnUnReg: getServicesRequestByIdData.exportHorseSemenDto.damEnUnReg != null ? getServicesRequestByIdData.exportHorseSemenDto.damEnUnReg : "",
        // damArUnReg: getServicesRequestByIdData.exportHorseSemenDto.damArUnReg != null ? getServicesRequestByIdData.exportHorseSemenDto.damArUnReg : "",
        // sireEnUnReg: getServicesRequestByIdData.exportHorseSemenDto.sireEnUnReg != null ? getServicesRequestByIdData.exportHorseSemenDto.sireEnUnReg : "",
        // sireArUnReg: getServicesRequestByIdData.exportHorseSemenDto.sireArUnReg != null ? getServicesRequestByIdData.exportHorseSemenDto.sireArUnReg : "",
        // breederNameEnUnReg: getServicesRequestByIdData.exportHorseSemenDto.breederNameEnUnReg != null ? getServicesRequestByIdData.exportHorseSemenDto.breederNameEnUnReg : "",
        // breederNameArUnReg: getServicesRequestByIdData.exportHorseSemenDto.breederNameArUnReg != null ? getServicesRequestByIdData.exportHorseSemenDto.breederNameArUnReg : "",
        // regoNoUnReg: getServicesRequestByIdData.exportHorseSemenDto.regoNoUnReg != null ? getServicesRequestByIdData.exportHorseSemenDto.regoNoUnReg : "",

        // colorUnReg: getServicesRequestByIdData.exportHorseSemenDto.colorUnReg != null ? getServicesRequestByIdData.exportHorseSemenDto.colorUnReg : "",
        // colorUnRegDrop: {
        //   label: getServicesRequestByIdData.exportHorseSemenDto.colorNameUnReg,
        //   value: getServicesRequestByIdData.exportHorseSemenDto.colorUnReg,
        // },
        // originUnReg: getServicesRequestByIdData.exportHorseSemenDto.originUnReg != null ? getServicesRequestByIdData.exportHorseSemenDto.originUnReg : "",
        // originUnRegDrop: {
        //   label: getServicesRequestByIdData.exportHorseSemenDto.originNameUnReg,
        //   value: getServicesRequestByIdData.exportHorseSemenDto.originUnReg,
        // },
        // horseCountryUnReg: getServicesRequestByIdData.exportHorseSemenDto.horseCountryUnReg != null ? getServicesRequestByIdData.exportHorseSemenDto.horseCountryUnReg : "",
        // horseCountryUnRegDrop: {
        //   label: getServicesRequestByIdData.exportHorseSemenDto.horseCountryNameUnReg,
        //   value: getServicesRequestByIdData.exportHorseSemenDto.horseCountryUnReg,
        // },
        // birthDateUnReg: getServicesRequestByIdData.exportHorseSemenDto.birthDateUnReg != null ? dayjs(getServicesRequestByIdData.exportHorseSemenDto.birthDateUnReg).format("YYYY-MM-DD") : null,

        exportTo: getServicesRequestByIdData.exportHorseSemenDto.exportTo,
        exportToDrop: {
          label: getServicesRequestByIdData.exportHorseSemenDto.exportToName,
          value: getServicesRequestByIdData.exportHorseSemenDto.exportTo,
        },
        approvedCollectionCenter: getServicesRequestByIdData.exportHorseSemenDto.approvedCollectionCenter,
        noOfStraws: getServicesRequestByIdData.exportHorseSemenDto.noOfStraws,
        noOfDoses: getServicesRequestByIdData.exportHorseSemenDto.noOfDoses,
        dispatchNumber: getServicesRequestByIdData.exportHorseSemenDto.dispatchNumber,
        exportDate: getServicesRequestByIdData.exportHorseSemenDto.exportDateDateTime != null ? dayjs(getServicesRequestByIdData.exportHorseSemenDto.exportDateDateTime).format("YYYY-MM-DD") : null,
        uaeHospitalSemenStocking: getServicesRequestByIdData.exportHorseSemenDto.uaeHospitalSemenStocking,
        shippingAgentId: getServicesRequestByIdData.exportHorseSemenDto.shippingAgentId,
        shippingAgentDrop: {
          label: getServicesRequestByIdData.exportHorseSemenDto.shippingAgentName,
          value: getServicesRequestByIdData.exportHorseSemenDto.shippingAgentId,
        },

        ownerComment: getServicesRequestByIdData.exportHorseSemenDto.ownerComment != null ? getServicesRequestByIdData.exportHorseSemenDto.ownerComment : "",

        filePathLetterSemenStorageCenter: getServicesRequestByIdData.exportHorseSemenDto.letterSemenStorageCenterAttachmentFileModel != null ? getServicesRequestByIdData.exportHorseSemenDto.letterSemenStorageCenterAttachmentFileModel.filePath : "",
        fileTypeLetterSemenStorageCenter: getServicesRequestByIdData.exportHorseSemenDto.letterSemenStorageCenterAttachmentFileModel != null ? getServicesRequestByIdData.exportHorseSemenDto.letterSemenStorageCenterAttachmentFileModel.fileType : "",
        fileNameLetterSemenStorageCenter: getServicesRequestByIdData.exportHorseSemenDto.letterSemenStorageCenterAttachmentFileModel != null ? getServicesRequestByIdData.exportHorseSemenDto.letterSemenStorageCenterAttachmentFileModel.fileName : "",
        fileUrlLetterSemenStorageCenter: getServicesRequestByIdData.exportHorseSemenDto.letterSemenStorageCenterAttachmentFileModel != null ? getServicesRequestByIdData.exportHorseSemenDto.letterSemenStorageCenterAttachmentFileModel.fileUrl : "",
      });

      //another owner
      if (
        getServicesRequestByIdData.exportHorseSemenDto.ownerId !==
        getServicesRequestByIdData.exportHorseSemenDto.createdBy &&
        subOwnerProfilesByIdData.length > 0 &&
        getServicesRequestByIdData.requestsType !== "BackOffice"
      ) {
        //update profile
        setProfile({
          label:
            subOwnerProfilesByIdData.filter(
              (item) =>
                item.value ==
                getServicesRequestByIdData.exportHorseSemenDto.ownerId
            )[0].registerNo +
            " - " +
            subOwnerProfilesByIdData.filter(
              (item) =>
                item.value ==
                getServicesRequestByIdData.exportHorseSemenDto.ownerId
            )[0][`text${currentLanguage === "en" ? "" : "Ar"}`],
          value: subOwnerProfilesByIdData.filter(
            (item) =>
              item.value == getServicesRequestByIdData.exportHorseSemenDto.ownerId
          )[0].value,
        });
      }
    }
  }, [
    getServicesRequestByIdData,
  ]);

  useEffect(() => {
    if (
      toasterMessageServicesRequests != null &&
      toasterMessageServicesRequests === "save"
    ) {
      if (_isOnlinePayment.current !== "") {
        toast.success(
          translate(
            "web.yourRequestHasSubmittedSuccessfully",
            "Your Request Has Submitted Successfully"
          )
        );
      } else {
        toast.success(
          translate("web.dataSavedSuccessfully", "Data Saved Successfully")
        );
      }

      dispatch(resetToasterMessageServicesRequests());

      setTimeout(() => {
        if (_isOnlinePayment.current !== "") {
          const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}&serviceId=${createOrEditExportHorseSemenData.id}`;

          const encodeURI = encodeURIComponent(returnUrl);

          window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${createOrEditExportHorseSemenData.id}&paymentType=28&userId=${localStorage.getItem(
            "EAHSUserID"
          )}&returnUrl=${encodeURI}&isOnline=${_isOnlinePayment.current}&lang=${currentLanguage}`;
        } else {
          if (_status.current === "Submit" && formModel.eventName !== "SentBack") {
            navigate(`/profile?activeTab=${"e_services"}&serviceId=${createOrEditExportHorseSemenData.id}`);
          }
          else {
            navigate(`/profile?activeTab=${"e_services"}`);
          }
        }
      }, 1000);
    }

    //error
    else if (toasterMessageServicesRequests != null && toasterMessageServicesRequests !== "save") {
      if (toasterMessageServicesRequests !== "errorServiceDetails") {

        toast.error(
          translate(toasterMessageServicesRequests, toasterMessageServicesRequests)
        );

        dispatch(resetToasterMessageServicesRequests());
      }

      else if (toasterMessageServicesRequests === "errorServiceDetails") {
        toast.error(
          translate("web.createServiceRequestFailed", "Service Request Failed")
        );

        dispatch(resetToasterMessageServicesRequests());

        setTimeout(() => {
          navigate(`/profile?activeTab=${"e_services"}`);
        }, 1000);
      }
    }
  }, [toasterMessageServicesRequests]);

  useEffect(() => {
    if (getServiceDefinitionByIdData?.termsList) {
      const initialState = {};
      getServiceDefinitionByIdData.termsList.forEach((_, index) => {
        initialState[`option${index + 1}`] = false;
      });
      setCheckedItems(initialState);
    }
  }, [getServiceDefinitionByIdData?.termsList]);

  return (
    <>
      {/* loading div */}
      <div
        className={`page-overlay text-center ${servicesRequestsLoading
          ? "classdisplay"
          : "classnotdisplay"
          }`}
      >
        <div className="loaderDiv">
          <Loader />
        </div>
      </div>

      {/* toast */}
      <ToastContainer
        position="top-right"
        onClick={dismissAll}
        theme="colored"
        autoClose={5000}
      />

      {/* content page */}
      <div className={serviceRequestHeadContainer}>

        {/* update Arabian Horse Data */}
        <h2 className={serviceRequestTitle}>

          {currentLanguage === "en"
            ? getServiceDefinitionByIdData.nameEn
            : getServiceDefinitionByIdData.nameAr} {formModel.referenceNumber}{" "}
        </h2>

        {/* Selected Account */}
        {subOwnerProfilesByIdData.length > 0 &&
          (action == null || action === "edit") &&
          (
            <div className={userDropDown}>
              {!!userProfile && userProfile?.accountType !== "Agent" ? (
                <>
                  <NetaqInput
                    label={translate("web.selectedAccount", "Selected Account")}
                    name="selectAccount"
                    type="select"
                    listSelect={[
                      ...(!!subOwnerProfilesByIdData &&
                        !!subOwnerProfilesByIdData.length > 0 &&
                        subOwnerProfilesByIdData.map((a) => ({
                          label:
                            a?.registerNo +
                            " - " +
                            a[`text${currentLanguage === "en" ? "" : "Ar"}`],
                          value: a.value,
                        }))),
                    ]}
                    value={profile}
                    onChange={(e) => {
                      handelSelectedAccountChange(e);
                    }}
                    placeholder={localStorage.getItem("EAHSUserFullName")}
                  />
                </>
              ) : (
                <label className="capatalize_text">
                  {getSelectedAccountName()?.registerNo +
                    " - " +
                    getSelectedAccountName()[
                    `text${currentLanguage === "en" ? "" : "Ar"}`
                    ]}
                </label>
              )}
            </div>
          )}
      </div>
      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.stallionDetails", "Stallion Details")}>
        <div className="row mx-0">
          <label>
            {translate("web.horseType", "Horse Type")}
          </label>
          <div className={eformCheckBox}>
            <NetaqInput
              name={"horseType"}
              type={"radioServiceRequest"}
              value={"Registered"}
              label={`${translate("web.registered", "Registered")}-`}
              onChange={(e) => handleFormChange(e, "horseType")}
              checked={
                formModel.horseType === "Registered"
              }
              disabled={handelDisabledButton()}
            />
          </div>

          <div className={eformCheckBox}>
            <NetaqInput
              name={"horseType"}
              type={"radioServiceRequest"}
              value={"UnRegistered"}
              label={`${translate("web.unregistered", "Unregistered")}-`}
              onChange={(e) => handleFormChange(e, "horseType")}
              checked={
                formModel.horseType === "UnRegistered"
              }
              disabled={handelDisabledButton()}
            />
          </div>
        </div>

        {formModel.horseType === "Registered" && (
          <div className={eformInput}>
            <label>
              {translate("web.stallionName", "Stallion Name")}
              <i className=" colorred"> *</i>
            </label>
            <Select
              options={[
                {
                  label: translate("web.horse", "Horse"),
                  value: null,
                },
                ...(!!ownerStallionsData &&
                  ownerStallionsData.map((a) => ({
                    label: a.name,
                    value: a.id,
                  }))),
              ]}
              value={formModel.stallionDrop}
              onChange={(e) => handleFormChange(e, "stallion")}
              placeholder={translate("web.stallionName", "Stallion Name")}
              name={"stallion"}
              isSearchable
              noOptionsMessage={() =>
                translate("web.noOptions", "No Options")
              }
              autoFocus={true}
              key={"stallion"}
              isDisabled={
                ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                  true
                  : false
              }
              ref={stallionIdRef}
            />
            {errorStallionId && (
              <span style={{ color: "red" }}>
                {translate("web.requiredField", "Required Field")}
              </span>
            )}
          </div>
        )}
        {formModel.horseType === "UnRegistered" && (
          <>
            <div className={eformInput}>
              <label>
                {translate("web.importHorseFrozenSemen", "Import Horse Frozen Semen")}
                <i className="colorred"> *</i>
              </label>
              <Select
                options={[
                  {
                    label: translate("web.importHorseFrozenSemen", "Import Horse Frozen Semen"),
                    value: null,
                  },
                  ...(!!ownerImportHorseFrozenSemenListData &&
                    ownerImportHorseFrozenSemenListData.map((a) => ({
                      label: a.name,
                      value: a.id,
                    }))),
                ]}
                value={formModel.importHorseFrozenSemenServiceIdDrop}
                onChange={(e) => handleFormChange(e, "importHorseFrozenSemenServiceId")}
                placeholder={translate("web.importHorseFrozenSemen", "Import Horse Frozen Semen")}
                name={"importHorseFrozenSemenServiceId"}
                isSearchable
                noOptionsMessage={() =>
                  translate("web.noOptions", "No Options")
                }
                key={"importHorseFrozenSemenServiceId"}
                isDisabled={handelDisabledButton()}
                ref={importHorseFrozenSemenServiceIdRef}
              />
              {errorImportHorseFrozenSemenServiceId && (
                <span style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </span>
              )}
            </div>
            <div className={eformInput}>
              <label>
                {translate("web.semenCollectionCertificateIds", "Semen Collection Certificate IDs")}
                <i className="colorred"> *</i>
              </label>
              <Select
                isMulti
                options={[
                  ...semenCertList.map(cert => ({
                    label: cert.name,
                    value: cert.id
                  }))
                ]}
                value={formModel.semenCollectionCertificateIdsDrop}
                onChange={(e) => handleFormChange(e, "semenCollectionCertificateIds")}
                placeholder={translate("web.semenCollectionCertificateIds", "Semen Collection Certificate IDs")}
                name={"semenCollectionCertificateIds"}
                isSearchable
                noOptionsMessage={() =>
                  translate("web.noOptions", "No Options")
                }
                key={"semenCollectionCertificateIds"}
                isDisabled={handelDisabledButton()}
                ref={semenCollectionCertificateIdsRef}
              />
              {errorSemenCollectionCertificateIds && (
                <span style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </span>
              )}
            </div>

            {/* <div className={eformInput}>
              <NetaqInput
                label={translate("web.horse", "Horse") + " (EN)"}
                name={"horseNameEnUnReg"}
                type={"text"}
                required={true}
                value={formModel.horseNameEnUnReg}
                onChange={(e) => handleFormChange(e, "horseNameEnUnReg")}
                disabled={handelDisabledButton()}
                ref={horseNameEnUnRegRef}
              />
              {errorHorseNameEnUnReg && (
                <span style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </span>
              )}
            </div>
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.horse", "Horse") + " (AR)"}
                name={"horseNameArUnReg"}
                type={"text"}
                required={true}
                value={formModel.horseNameArUnReg}
                onChange={handleFormChange}
                disabled={handelDisabledButton()}
                ref={horseNameArUnRegRef}
              />
              {errorHorseNameArUnReg && (
                <span style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </span>
              )}
            </div>
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.dam", "Dam") + " (EN)"}
                name={"damEnUnReg"}
                type={"text"}
                required={true}
                value={formModel.damEnUnReg}
                onChange={(e) => handleFormChange(e, "damEnUnReg")}
                disabled={handelDisabledButton()}
                ref={damEnUnRegRef}
              />
              {errorDamEnUnReg && (
                <span style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </span>
              )}
            </div>
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.dam", "Dam") + " (AR)"}
                name={"damArUnReg"}
                type={"text"}
                required={true}
                value={formModel.damArUnReg}
                onChange={handleFormChange}
                disabled={handelDisabledButton()}
                ref={damArUnRegRef}
              />
              {errorDamArUnReg && (
                <span style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </span>
              )}
            </div>
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.sire", "Sire") + " (EN)"}
                name={"sireEnUnReg"}
                type={"text"}
                required={true}
                value={formModel.sireEnUnReg}
                onChange={(e) => handleFormChange(e, "sireEnUnReg")}
                disabled={handelDisabledButton()}
                ref={sireEnUnRegRef}
              />
              {errorSireEnUnReg && (
                <span style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </span>
              )}
            </div>
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.sire", "Sire") + " (AR)"}
                name={"sireArUnReg"}
                type={"text"}
                required={true}
                value={formModel.sireArUnReg}
                onChange={handleFormChange}
                disabled={handelDisabledButton()}
                ref={sireArUnRegRef}
              />
              {errorSireArUnReg && (
                <span style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </span>
              )}
            </div>
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.breeder", "Breeder") + " (EN)"}
                name={"breederNameEnUnReg"}
                type={"text"}
                required={true}
                value={formModel.breederNameEnUnReg}
                onChange={(e) => handleFormChange(e, "breederNameEnUnReg")}
                disabled={handelDisabledButton()}
                ref={breederNameEnUnRegRef}
              />
              {errorBreederNameEnUnReg && (
                <span style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </span>
              )}
            </div>
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.breeder", "Breeder") + " (AR)"}
                name={"breederNameArUnReg"}
                type={"text"}
                required={true}
                value={formModel.breederNameArUnReg}
                onChange={handleFormChange}
                disabled={handelDisabledButton()}
                ref={breederNameArUnRegRef}
              />
              {errorBreederNameArUnReg && (
                <span style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </span>
              )}
            </div>
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.regno", "Reg.No")}
                name={"regoNoUnReg"}
                type={"text"}
                onChange={handleFormChange}
                value={formModel.regoNoUnReg}
                required={true}
                disabled={handelDisabledButton()}
                ref={regoNoUnRegRef}
              />
              {errorRegoNoUnReg && (
                <span style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </span>
              )}
            </div>
            <div className={eformInput}>
              <label>
                {translate("web.color", "Color")}
                <i className="colorred"> *</i>
              </label>
              <Select
                options={[
                  {
                    label: translate("web.color", "Color"),
                    value: null,
                  },
                  ...(!!horseColorsData &&
                    horseColorsData.map((a) => ({
                      label: a.nameEn,
                      value: a.id,
                    }))),
                ]}
                value={formModel.colorUnRegDrop}
                onChange={(e) => handleFormChange(e, "colorUnReg")}
                placeholder={translate("web.color", "Color")}
                name={"colorUnReg"}
                isSearchable
                noOptionsMessage={() =>
                  translate("web.noOptions", "No Options")
                }
                key={"colorUnReg"}
                isDisabled={handelDisabledButton()}
                ref={colorUnRegRef}
              />
              {errorColorUnReg && (
                <span style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </span>
              )}
            </div>
            <div className={eformInput}>
              <label>
                {translate("web.origin", "Origin")}
                <i className="colorred"> *</i>
              </label>
              <Select
                options={[
                  {
                    label: translate("web.chooseOrigin", "Choose Origin"),
                    value: null,
                  },
                  ...(!!countriesData &&
                    countriesData.map((a) => ({
                      label: a.text,
                      value: a.value,
                    }))),
                ]}
                value={formModel.originUnRegDrop}
                onChange={(e) => handleFormChange(e, "originUnReg")}
                placeholder={translate("web.chooseOrigin", "Choose Origin")}
                name={"originUnReg"}
                isSearchable
                noOptionsMessage={() =>
                  translate("web.noOptions", "No Options")
                }
                key={"originUnReg"}
                isDisabled={handelDisabledButton()}
                ref={originUnRegRef}
              />
              {errorOriginUnReg && (
                <span style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </span>
              )}
            </div>

            <div className={eformInput}>
              <label>
                {translate("web.horseCountry", "Horse Country")}
                <i className="colorred"> *</i>
              </label>
              <Select
                options={[
                  {
                    label: translate("web.horseCountry", "Horse Country"),
                    value: null,
                  },
                  ...(!!countriesData &&
                    countriesData.map((a) => ({
                      label: a.text,
                      value: a.value,
                    }))),
                ]}
                value={formModel.horseCountryUnRegDrop}
                onChange={(e) => handleFormChange(e, "horseCountryUnReg")}
                placeholder={translate("web.horseCountry", "Horse Country")}
                name={"horseCountryUnReg"}
                isSearchable
                noOptionsMessage={() =>
                  translate("web.noOptions", "No Options")
                }
                key={"horseCountryUnReg"}
                isDisabled={handelDisabledButton()}
                ref={horseCountryUnRegRef}
              />
              {errorHorseCountryUnReg && (
                <span style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </span>
              )}
            </div>
           
            <div className={eformInput}>
              <NetaqInput
                htmlTags={
                  formModel.birthDateUnReg ?
                    <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                      {
                        dayjs(formModel.birthDateUnReg).format("DD/MM/YYYY")
                      }
                    </p> :
                    <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                      DD/MM/YYYY
                    </p>
                }
                name={"birthDateUnReg"}
                type={"normalDateService"}
                label={translate("web.birthDate", "Birth Date")}
                onChange={(e) => handleFormChange(e, "birthDateUnReg")}
                value={formModel.birthDateUnReg}
                required={true}
                maxDate={dayjs().format("YYYY-MM-DD")}
                disabled={handelDisabledButton()}
                ref={birthDateUnRegRef}
              />
              {errorBirthDateUnReg && (
                <span style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </span>
              )}
            </div> */}
          </>
        )}

        <div className={eformInput}>
          <label>
            {translate("web.exportTo", "Export To")}
            <i className=" colorred"> *</i>
          </label>
          <Select
            options={[
              {
                label: translate("web.chooseCountry", "Choose Country"),
                value: null,
              },
              ...(!!studBookCountries &&
                studBookCountries.map((a) => ({
                  label: a.text,
                  value: a.value,
                }))),
            ]}
            value={formModel.exportToDrop}
            onChange={(e) => handleFormChange(e, "exportTo")}
            placeholder={translate("web.chooseCountry", "Choose Country")}
            name={"exportTo"}
            isSearchable
            noOptionsMessage={() =>
              translate("web.noOptions", "No Options")
            }
            autoFocus={true}
            key={"exportTo"}
            isDisabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={exportToRef}
          />
          {errorExportTo && (
            <span style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </span>
          )}
        </div>
      </EahsForm>

      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.approvedCollectionCenterDetails", "Approved Collection Center Details")}>
        <div className={eformInput}>
          <NetaqInput
            label={translate("web.approvedCollectionCenter", "Approved Collection Center")}
            name={"approvedCollectionCenter"}
            type={"text"}
            onChange={handleFormChange}
            value={formModel.approvedCollectionCenter}
            required={true}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={approvedCollectionCenterRef}
          />
          {
            errorApprovedCollectionCenter &&
            <p style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </p>
          }
        </div>

        <div className={eformInput}>
          <NetaqInput
            name={"noOfStraws"}
            key={"noOfStraws"}
            type={"number"}
            required={true}
            value={formModel.noOfStraws}
            minValue={1}
            label={translate("web.noStraws", "No Of Straws")}
            onChange={handleFormChange}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={noOfStrawsRef}
          />
          {errorNoOfStraws &&
            <p style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </p>
          }
        </div>

        <div className={eformInput}>
          <NetaqInput
            name={"noOfDoses"}
            key={"noOfDoses"}
            type={"number"}
            required={true}
            incomingValue={formModel?.noOfDoses}
            minValue={1}
            label={translate("web.noDoses", "No Of Doses")}
            onChange={handleFormChange}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view" || formModel.horseType === "UnRegistered") ?
                true
                : false
            }
            ref={noOfDosesRef}
          />
          {
            errorNoOfDoses &&
            <p style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </p>
          }
        </div>

        <div className={eformInput}>
          <NetaqInput
            name={"dispatchNumber"}
            key={"dispatchNumber"}
            type={"number"}
            required={true}
            value={formModel.dispatchNumber}
            minValue={1}
            label={translate("web.dispatchNumber", "Dispatch Number")}
            onChange={handleFormChange}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={dispatchNumberRef}
          />
          {errorDispatchNumber &&
            <p style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </p>
          }
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.uaeHospitalSemenStocking", "UAE Hospital Semen Stocking")}
            name={"uaeHospitalSemenStocking"}
            type={"text"}
            onChange={handleFormChange}
            value={formModel.uaeHospitalSemenStocking}
            required={true}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={uaeHospitalSemenStockingRef}
          />
          {errorUaeHospitalSemenStocking &&
            <p style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </p>
          }
        </div>

        <div className={eformInput}>
          <NetaqInput
            htmlTags={
              formModel.exportDate ?
                <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                  {
                    dayjs(formModel.exportDate).format("DD/MM/YYYY")
                  }
                </p> :
                <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                  DD/MM/YYYY
                </p>
            }
            name={"exportDate"}
            type={"normalDateService"}
            label={translate("web.exportDate", "Date Of Export")}
            onChange={handleFormChange}
            value={formModel.exportDate}
            required={true}
            minDate={dayjs().format("YYYY-MM-DD")}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={exportDateRef}
          />
          {errorExportDate &&
            <p style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </p>
          }
        </div>
      </EahsForm>

      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.shippingAgent", "Shipping Agent")}>
        <div className={eformInput}>
          <label>
            {translate("web.shippingAgent", "Shipping Agent")}
            <i className=" colorred"> *</i>
          </label>
          <Select
            options={[
              {
                label: translate("web.shippingAgent", "Shipping Agent"),
                value: null,
              },
              ...(!!getShippingAgentsData &&
                getShippingAgentsData.map((a) => ({
                  label: a.text,
                  value: a.value,
                }))),
              {
                label: translate("web.other", "Other"),
                value: 0,
              }
            ]}
            value={formModel.shippingAgentDrop}
            onChange={(e) => handleFormChange(e, "shippingAgent")}
            placeholder={translate("web.shippingAgent", "Shipping Agent")}
            name={"shippingAgent"}
            isSearchable
            noOptionsMessage={() =>
              translate("web.noOptions", "No Options")
            }
            autoFocus={true}
            key={"shippingAgent"}
            isDisabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={shippingAgentIdRef}
          />
          {errorShippingAgentId && (
            <span style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </span>
          )}
        </div>

        {formModel.shippingAgentId === 0 &&
          <>
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.name", "Name") + " (EN)"}
                name={"shippingAgentNameEn"}
                type={"text"}
                onChange={(e) => handleFormChange(e, "shippingAgentNameEn")}
                value={formModel.shippingAgentNameEn}
                required={true}
                ref={shippingAgentNameEnRef}
              />
              {errorShippingAgentNameEn &&
                <p style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </p>
              }
            </div>
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.name", "Name") + " (AR)"}
                name={"shippingAgentNameAr"}
                type={"text"}
                onChange={handleFormChange}
                value={formModel.shippingAgentNameAr}
                required={true}
                ref={shippingAgentNameArRef}
              />
              {errorShippingAgentNameAr &&
                <p style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </p>
              }
            </div>
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.email", "Email")}
                name={"shippingAgentEmail"}
                type={"text"}
                onChange={handleFormChange}
                value={formModel.shippingAgentEmail}
                required={true}
                ref={shippingAgentEmailRef}
              />
              {errorShippingAgentEmail &&
                <p style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </p>
              }
            </div>
            <div className={eformInput}>
              <NetaqInput
                type={'phone'}
                value={formModel.shippingAgentMobile}
                label={translate("web.smsPhoneNo", "Mobile No")}
                name={'shippingAgentMobile'}
                placeholder={'971xxxxxxxxx'}
                required={true}
                onChange={setPhoneNumber}
                setIsPhoneNumberValid={setIsPhoneNumberValid}
                ref={shippingAgentEmailRef}
              />
              {!isPhoneNumberValid &&
                <div className='text-danger'>
                  {translate('web.phoneNumberIsNotValid', 'Phone Number Is Not Valid')}
                </div>
              }
              {errorShippingAgentMobile && (
                <span
                  style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </span>
              )}
            </div>
          </>
        }
      </EahsForm>

      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.uploadDocument", "Upload Document")}>
        <div className={eformInput}>
          <label>
            {translate("web.letterSemenStorageCenter", "Letter Semen Storage Center")}
            <i className=" colorred"> *</i>
          </label>
          <SimpleFileUpload
            isMulti={false}
            initialFiles={
              !!formModel.filePathLetterSemenStorageCenter &&
                !!formModel.fileUrlLetterSemenStorageCenter &&
                letterSemenStorageCenterAttachmentFile.length === 0
                ? [
                  {
                    // file: base64ToBlob(
                    //   formModel.documentBase64LetterSemenStorageCenter,
                    //   formModel.fileTypeLetterSemenStorageCenter ===
                    //     ".pdf"
                    //     ? "application/pdf"
                    //     : "image/png"
                    // ),
                    file: formModel?.fileUrlLetterSemenStorageCenter,
                    name: formModel?.fileNameLetterSemenStorageCenter,
                  },
                ]
                : letterSemenStorageCenterAttachmentFile
            }
            isServer={
              !!formModel.filePathLetterSemenStorageCenter &&
                !!formModel.fileUrlLetterSemenStorageCenter &&
                letterSemenStorageCenterAttachmentFile.length === 0
                ? true
                : false
            }
            onChange={handleUploadLetterSemenStorageCenterChange}
            accept={"image/*,application/pdf"}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={letterSemenStorageCenterRef}
          />
          {
            errorLetterSemenStorageCenter && (
              <span style={{ color: "red" }}>
                {translate("web.requiredField", "Required Field")}
              </span>
            )}
        </div>
      </EahsForm>

      {/* Comments */}
      {(!!formModel.comment || !!formModel.ownerComment) && (
        <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.comments", "Comments")}>
          {!!formModel.comment && (
            // eahs Comment
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.eahsComments", "EAHS Comments")}
                name={"adminComment"}
                type={"textarea"}
                maxchars={1150}
                value={formModel.comment}
                disabled={true}
              />
            </div>
          )}

          {(!!formModel.ownerComment || formModel.eventName === "SentBack") && (
            // owner Comment 
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.ownerComment", "Owner Comment")}
                name={"ownerComment"}
                type={"textarea"}
                maxchars={1150}
                value={formModel.ownerComment}
                onChange={handleFormChange}
                disabled={formModel.eventName !== "SentBack" ? true : false}
              />
            </div>
          )}
        </EahsForm>
      )}

      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.terms", "Terms")}>
        {getServiceDefinitionByIdData?.termsList?.map((item, index) => {
          return (
            <div className={eformTerms} key={index}>
              <NetaqInput
                type={"checkbox"}
                label={item}
                name={`option${index + 1}`}
                checked={checkedItems[`option${index + 1}`] || action != null}
                onChange={handleCheckboxChange}
                disabled={formModel.eventName !== ""}
              />
            </div>
          );
        })}
      </EahsForm>

      {/* buttons*/}
      <div className={eFormButtonsContainer}>
        {/* draft/pay/submit btn */}
        {(
          (action == null || action === "edit")
          ||
          (action === "approve"
            &&
            (
              formModel.eventName === "SentBack"
              ||
              (formModel.paymentStatus === "Pendding" && formModel.requestsType === "BackOffice")
            )
          )
        ) && (
            <>
              {(formModel.eventName === "" || formModel.eventName === "Draft") &&
                <DraftBtn onClick={() => handelFormSubmit("Draft", "", "Draft")}
                  isDisabled={
                    formModel.eventName === "" ||
                      formModel.eventName === "Draft"
                      ? false
                      : true
                  } />
              }

              {userProfile?.participateWithoutPayment === true && formModel.eventName !== "SentBack" && action !== "view" && getServiceDefinitionByIdData.serviceFees > 0 && (
                <ApproveAndPayLaterBtn
                  selectedAccountId={profile?.value}
                  isApprove={false} onClick={() =>
                    handelFormSubmit("Draft", "no", "Pay")
                  }
                  isDisabled={
                    formModel.eventName === "SentBack"
                      ? true
                      : false
                  } />
              )}

              {formModel.eventName !== "SentBack" && action !== "view" && getServiceDefinitionByIdData.serviceFees > 0 && (
                <SubmitAndPay
                  selectedAccountId={profile?.value}
                  onClick={() =>
                    handelFormSubmit("Draft", "yes", "Pay")
                  }
                  isDisabled={
                    formModel.eventName === "SentBack"
                      ? true
                      : false
                  }
                />
              )}

              {(getServiceDefinitionByIdData.serviceFees === 0 || (formModel.eventName === "SentBack" && action !== "view")) && (
                <SubmitServiceBtn
                  onClick={() =>
                    handelFormSubmit("Submit", "", "Submit")
                  }
                  isDisabled={
                    getServiceDefinitionByIdData.serviceFees === 0 || formModel.eventName === "SentBack"
                      ? false
                      : true
                  }
                />
              )}
            </>
          )}
      </div>
    </>
  );
}
